import React, { useContext, useState } from 'react';
import { Checkbox, CheckboxChangeEvent } from '@progress/kendo-react-inputs';
import FilterCtx from '../../../../context/filterContext/filterCtx';
import useTranslate from '../../../../common/hooks/useTranslate';
import DocNameFilter from '../../../ui/filters/docNameFilter/docNameFilter';
import FundsFilter from '../../../ui/filters/fundsFilter/fundsFilter';
import InvestorsFilter from '../../../ui/filters/investorsFilter/investorsFilter';
import ClassificationsFilter from '../../../ui/filters/classificationsFilter/classificationsFilter';
import ReadFilter from '../../../ui/filters/readFilter/readFilter';
import DateFilter from '../../../ui/filters/dateFilter/dateFilter';
import PeriodsFilter from '../../../ui/filters/periodsFilter/periodsFilter';

import '@progress/kendo-theme-default/dist/all.css';
import '../documentsTable/documentsTable.scss';
import '../../../../common/styles/globalClasses.scss';
import '../../../ui/filters/filters.scss';

const DocumentFilters = ({className}) => {
  const filterCtx = useContext(FilterCtx);
  const [moreFiltersShown, setMoreFiltersShown] = useState(false);
  const [doRerender, setDoRerender] = useState(true);
  const [uniqueKey, setUniqueKey] = useState('');

  const { t } = useTranslate();

  const handlePublishDateCheckbox = (event: CheckboxChangeEvent) => {
    filterCtx.setPublishChecked(event.value);
  };

  const handleEffectiveDateCheckbox = (event: CheckboxChangeEvent) => {
    filterCtx.setEffectiveChecked(event.value);
  };

  const resetFilters = (): void => {
    filterCtx.clearFilters();
    setDoRerender(!doRerender);
    const date = new Date();
    setUniqueKey(date.toString());
  };

  const toggleFilters = (): void => {
    setMoreFiltersShown(!moreFiltersShown);
  };

  return (
    <>
      <div className={`filters ${className ? className : ''}`}>
        <DocNameFilter
          //@ts-ignore
          key={!doRerender}
          table="documents"
        />
        <div className="filters-multiselect">
          <ClassificationsFilter key={uniqueKey + 3} table="documents" toggleOn />
          <FundsFilter key={uniqueKey + 1} table="documents" toggleOn />
          <InvestorsFilter key={uniqueKey + 2} table="documents" toggleOn />
        </div>
        <PeriodsFilter key={uniqueKey + 4} toggleOn />
        <ReadFilter
          //@ts-ignore
          key={doRerender}
        />
        <button type="button" className="filter-button reset" disabled={!filterCtx.hasFilters()} onClick={resetFilters}>
          {t('FILTERS.BUTTON_RESET')}
        </button>

        {!moreFiltersShown && (
          <button type="button" className="filter-button" onClick={toggleFilters}>
            {t('FILTERS.BUTTON_MORE')}
          </button>
        )}
        {moreFiltersShown && (
          <button type="button" className="filter-button" onClick={toggleFilters}>
            {t('FILTERS.BUTTON_LESS')}
          </button>
        )}
      </div>
      {moreFiltersShown ? (
        <div className="more-filters k-align-items-center">
          <div className="dates-label">
            <span>{t('FILTERS.LABEL_DATES')}</span>
          </div>
          <Checkbox className="more-filters-dates" label={t('FILTERS.CHECKBOX_POSTED')} value={filterCtx.publishChecked} onChange={handlePublishDateCheckbox} />
          <Checkbox
            className="more-filters-dates"
            label={t('FILTERS.CHECKBOX_EFFECTIVE')}
            value={filterCtx.effectiveChecked}
            onChange={handleEffectiveDateCheckbox}
          />
          <div className="more-filters-dates">
            <DateFilter
              //@ts-ignore
              key={doRerender}
              dateType="FROM"
              disabled={!filterCtx.publishChecked && !filterCtx.effectiveChecked}
              placeholder={t('FILTERS.FROM_DATE')}
              table="documents"
            />
          </div>
          <div className="more-filters-dates">
            <DateFilter
              //@ts-ignore
              key={doRerender}
              dateType="TO"
              disabled={!filterCtx.publishChecked && !filterCtx.effectiveChecked}
              placeholder={t('FILTERS.TO_DATE')}
              table="documents"
            />
          </div>
        </div>
      ) : null}
    </>
  );
};

export default DocumentFilters;
